import React, { useEffect, useState } from "react";
import { EMPTY_STRING } from "../../../constants";

const SimpleCheckbox = ({
  name,
  label,
  onChange,
  isDisabled = false,
  isLabelLeft = false,
  checked: checkedProp,
  labelClassName = EMPTY_STRING,
}) => {
  const [checked, setChecked] = useState(!!checkedProp);

  const handleCheckboxChange = (event) => {
    setChecked(event.target.checked);
    if (onChange) {
      onChange(name, event.target.checked);
    }
  };

  // useState only uses checkedProp on the initial render.
  // Example:
  // 1. Initial render: checkedProp is undefined because backend data hasn't loaded yet.
  //    useState(!!checkedProp) initializes checked as false.
  // 2. Backend data is fetched and checkedProp becomes true/false.
  //    The component re-renders, but useState does NOT re-initialize with the new checkedProp.
  // 3. Sync the internal state whenever checkedProp changes so the checkbox reflects
  //    the latest value received from the backend.
  useEffect(() => {
    setChecked(!!checkedProp);
  }, [checkedProp]);

  return (
    <div>
      <div className="checkbox-field-wrapper">
        {isLabelLeft && (
          <label htmlFor={name} className={labelClassName}>
            {label}
          </label>
        )}
        <input
          id={name}
          name={name}
          className={`checkbox-field ${isDisabled ? "cursor-not-allowed" : ""}`}
          type="checkbox"
          checked={checked}
          onChange={handleCheckboxChange}
          disabled={isDisabled}
        />
        {!isLabelLeft && (
          <label htmlFor={name} className={`text-nowrap ${labelClassName}`}>
            {label}
          </label>
        )}
      </div>
    </div>
  );
};

export default SimpleCheckbox;
